import useIsMobile from 'utils/hooks/useIsMobile'
import CancelPresentationIcon from '@mui/icons-material/CancelPresentation'
import DoubleArrowIcon from '@mui/icons-material/DoubleArrow'
import ListAltIcon from '@mui/icons-material/ListAlt'
import RotateLeftTwoToneIcon from '@mui/icons-material/RotateLeftTwoTone'
import SearchIcon from '@mui/icons-material/Search'
import {
  Backdrop,
  Button,
  Chip,
  FormControl,
  InputLabel,
  MenuItem,
  Modal,
  Select,
  TextField,
} from '@mui/material'
import Box from '@mui/material/Box'
import Paper from '@mui/material/Paper'
import {DataGridPro, GridColDef, useGridApiRef} from '@mui/x-data-grid-pro'
import {DateRangePicker, LocalizationProvider} from '@mui/x-date-pickers-pro'
import {AdapterDayjs} from '@mui/x-date-pickers-pro/AdapterDayjs'
import {DateRange} from '@mui/x-date-pickers-pro/DateRangePicker'
import {yMarker} from 'assets/imageDeclear'
import dayjs, {Dayjs} from 'dayjs'
import {envBackHost, envImagePath, serverLocalName} from 'GLOBAL/envVariables'
import {axiosWithAuth} from 'helper/axiosWithAuth'
import fileDownload from 'js-file-download'
import _ from 'lodash'
import {customerTargetListRows} from 'pages/customer/dataConfig/declearRows'
import {targetImageLightBoxStyle} from 'pages/customer/dataConfig/LightBoxConfig'
import React, {useEffect, useRef, useState} from 'react'
import Lightbox from 'react-image-lightbox'
import 'react-image-lightbox/style.css'
import {useSelector} from 'react-redux'
import {
  globalFormatWithHyphens,
  globalSerialNumberFormatWithHyphens,
} from 'utils/const/globalConst'
import {showTemperatureHandler} from 'utils/const/globalController'
import {confirmAlert, resultAlert} from 'utils/CustomAlert/Alert'
import useMobileBackClose from 'utils/hooks/useMobileBackClose'
import {CustomerDetailChartFix} from './CustomerDetailChartFixed'
import './print.css'
/*********************************************************************
 ** Test Data
 *********************************************************************/

/*********************************************************************
 * 1. Init Libs
 *********************************************************************/
const style = {
  position: 'absolute' as 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  width: '90%',
  height: '90%',
  bgcolor: 'background.paper',
  overflow: 'hidden',
  display: 'flex',
  flexDirection: 'column',
  borderRadius: '12px',
  boxShadow: 24,
  p: {xs: 1, md: 4},
}
const CustomerStatusTargetImageListModal = (props: any) => {
  /*********************************************************************
   * 2. State settings (useState)
   *********************************************************************/
  const isMobile = useIsMobile()
  const {data, open, onClose} = props
  useMobileBackClose(open, onClose)
  const [date, setDate] = React.useState<DateRange<Dayjs>>([null, null])
  const [pageSize, setPageSize] = useState<number>(60)
  const [imageList, setImageList] = useState<any>(null)
  const [loading, setLoading] = useState(false)
  const [selectedOption, setSelectedOption] = useState<any>('reading')
  const officeInfo = useSelector((state: any) => state?.officeInfo)
  const userInfo = useSelector((state: any) => state?.userInfo?.userInfo)
  const [filter, setFilter] = useState<any>({
    startDate: date[0]
      ? date[0]?.format('YYYYMMDD')
      : dayjs().subtract(7, 'day').format('YYYYMMDD'),
    endDate: date[1] ? date[1]?.format('YYYYMMDD') : dayjs().format('YYYYMMDD'),
  })
  const [mobilePage, setMobilePage] = useState(0)
  const [isZoomOpen, setIsZoomOpen] = useState(false)
  const [selectedImage, setSelectedImage] = useState<any>('')
  const [rows, setRows] = useState<any[]>([])
  const [imageSizeCache, setImageSizeCache] = useState<
    Record<string, {width: number; height: number}>
  >({})
  /*********************************************************************
   * 3. Handlers (function)
   *********************************************************************/
  /**
   * 이전 수용가 (A)의 데이터가 B 수용가 모달 열었을때 보이던 버그 방지
   * setImageList(null)하나만 실행할경우 반영 제대로 안됨
   * setRows([]) 포함으로 확실하게 초기화 필요
   */
  const onCloseHandler = () => {
    setSelectedImage('') //선택 이미지
    setIsZoomOpen(false) // 줌 모달
    setImageList(null) // 이미지 리스트
    setRows([]) // 테이블 데이터(이미지 사이즈 추가)
    setLoading(false) // 로딩
    setImageSizeCache({})
    onClose() //부모창 모달
  }
  const getImageList = () => {
    setLoading(true)
    axiosWithAuth()
      .get(`${envBackHost}/${data?.officeId}/customer/${data?.customerNumber}/checkmeter`, {
        params: filter,
      })
      .then((res) => {
        const list = res.data.res
        const newRows = customerTargetListRows(list).map((row: any) => {
          const cached = imageSizeCache[row.filePath]
          return cached
            ? {...row, imageWidth: cached.width, imageHeight: cached.height}
            : {...row, imageWidth: null, imageHeight: null}
        })

        setRows(newRows)
        setMobilePage(0)
        setImageList(list)
        list.forEach((item: any) => {
          if (item.filePath && !imageSizeCache[item.filePath]) {
            const img = new Image()
            img.src = envImagePath + item.filePath
            img.onload = () => {
              const {width, height} = img
              setImageSizeCache((prev) => {
                const updated = {
                  ...prev,
                  [item.filePath]: {width, height},
                }
                setRows((prevRows: any[]) =>
                  prevRows.map((r) =>
                    r.filePath === item.filePath
                      ? {...r, imageWidth: width, imageHeight: height}
                      : r
                  )
                )

                return updated
              })
            }
          }
        })
      })
      .finally(() => setLoading(false))
  }

  const handleCellClick = (event: any) => {
    event.stopPropagation()
  }
  const getDownloadData = async () => {
    axiosWithAuth()
      .get(
        `${envBackHost}/${data?.officeId}/customer/${data?.customerNumber}/checkmeter/excel?startDate=${filter.startDate}&endDate=${filter?.endDate}`,
        {
          responseType: 'blob',
        }
      )
      .then(async (res) => {
        await resultAlert({resultCode: 0})
        fileDownload(
          res.data,
          `${globalFormatWithHyphens(data?.officeId, data?.customerNumber)}수용가_${
            filter.startDate
          }~${filter.endDate}_검침상세정보.xlsx`
        )
        await document.getElementById('downloadModalClose')?.click()
      })
      .catch(async (e) => {
        await resultAlert({resultCode: e.response.status})
      })
  }

  const updateCheckValuePost = async (row: any, newValue: string) => {
    const serverHandle = async () => {
      if (['sys_admin', 'sys_user'].includes(userInfo.accountType)) {
        return true
      } else {
        return await confirmAlert('수정', 'info')
      }
    }

    if (await serverHandle()) {
      try {
        const res = await axiosWithAuth().post(`${envBackHost}/checkmeter/update`, {
          idxDate: row.idxDate,
          value: newValue,
          imei: row.imei,
          updateId: userInfo.userId,
        })

        await resultAlert(res.data)

        if (res.data.resultCode === 0) {
          await getImageList()
        }
      } catch (e: any) {
        await resultAlert({resultCode: e.response?.status})
      }
    }
  }

  const accountTypeFixHandler = (type: string) => {
    switch (type) {
      case 'gov_meterman':
      case 'gov_coop':
        return false
      default:
        return true
    }
  }

  // const getRowHeightOnDataGrid = (params: any) => {
  //   const {recognizedType, imageHeight} = params?.model || {}
  //   if (recognizedType === 'PRV') {
  //     return 180
  //   }
  //   if (imageHeight && imageHeight > 144) {
  //     return imageHeight - 40
  //   }
  //   return 110
  // }

  const getRowHeightOnDataGrid = (params: any) => {
    const {imageHeight} = params?.model || {}
    // 매핑 테이블
    const heightMap: Record<number, number> = {
      480: 180,
      240: 160,
      144: 110,
    }

    if (imageHeight && heightMap[imageHeight]) {
      return heightMap[imageHeight]
    }
    // 기본값
    return 110
  }

  const buttonColor = (data: string) => {
    switch (data) {
      case 'COMPLETE':
        return 'success'
      case 'DIGIT':
        return 'warning'
      case 'FAIL':
        return 'error'
      case 'FIX':
        return 'info'
      case 'IMGERR':
        return 'error'
    }
  }

  const gridRef = useRef<HTMLDivElement>(null)

  const scrollToRow = (idxDate: any) => {
    const rowIndex = rows.findIndex((row) => row.idxDate === idxDate)
    if (gridRef.current) {
      const scrollableElement = gridRef.current.querySelector(
        '.MuiDataGrid-virtualScroller'
      ) as HTMLDivElement
      if (scrollableElement) {
        // here and should fin gridRef.current possible
      }
    }
  }

  const handleDateClick = (data: any) => {
    const date = dayjs(data, 'M월 D일').format('MMDD')
    let count = 0
    _.map(imageList, (el, idx) => {
      const column = Object.keys(el)
      return column.findIndex((column) => {
        if (el[column] !== null && el[column].includes(date) && column === 'idxDate') {
          if (count !== 0) {
          } else {
            count++
            return scrollToRow(el[column])
          }
        }
      })
    })
  }

  const apiRef = useGridApiRef()
  const mobileListRef = useRef<HTMLDivElement>(null)

  /*********************************************************************
   * 4. UseEffect
   *********************************************************************/
  /**
   * 항상 새로운 수용가 데이터를 보장하기 위한 이중 state 요청
   * 이전 이미지 리스트 제거 -> 이전 rows 제거 -> 서버에 새 데이터 요청
   */
  useEffect(() => {
    if (open && data) {
      setImageList(null)
      setRows([])
      getImageList()
    }
  }, [open, data, filter?.startDate, filter?.endDate])

  useEffect(() => {
    const today = dayjs()
    const oneWeekAgo = today.subtract(7, 'day')
    setDate([oneWeekAgo, today])
  }, [])

  useEffect(() => {
    if (open && data && data.latitude && data.longitude) {
      setTimeout(() => {
        let container = document?.getElementById('map')
        if (container) {
          const map = new window.kakao.maps.Map(container, {
            center: new window.kakao.maps.LatLng(data.latitude, data.longitude),
            mapTypeId: window.kakao.maps.MapTypeId.HYBRID,
            level: 1,
            draggable: false,
            scrollwheel: false,
            zoomable: false,
          })
          const mapTypeControl = new window.kakao.maps.MapTypeControl()
          map.addControl(mapTypeControl, window.kakao.maps.ControlPosition.TOPRIGHT)
          var markerPosition = new window.kakao.maps.LatLng(data.latitude, data.longitude)

          var marker = new window.kakao.maps.Marker({
            position: markerPosition,
            image: new window.kakao.maps.MarkerImage(yMarker, new window.kakao.maps.Size(40, 59)),
          })

          marker.setMap(map)
        }
      }, 300)
    }
  }, [open])

  /*********************************************************************
   * 5. DataGrid Props settings
   *********************************************************************/
  const columns: GridColDef[] = [
    {
      field: 'createAt',
      headerName: '검침일시',
      width: 260,
      align: 'center',
      headerAlign: 'center',
      renderCell: (params: any) => {
        return <div>{dayjs(params?.row?.createAt).format('YYYY-MM-DD HH시 mm분 ss초')}</div>
      },
    },
    {
      field: 'filePath',
      headerName: '검침 이미지',
      width: 250,
      align: 'center',
      headerAlign: 'center',
      hide: data?.deviceType === 'digital',
      renderCell: (params: any) => {
        return (
          <div
            className='cursor-zoom-in'
            style={{
              width: '100%',
              height: '100%',
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
              overflow: 'hidden',
            }}
          >
            <img
              onClick={() => {
                setIsZoomOpen(true)
                setSelectedImage(`${envImagePath + params?.row?.filePath}`)
              }}
              src={envImagePath + params?.row?.filePath}
              alt='check'
              style={{
                maxWidth: '100%',
                maxHeight: '100%',
                objectFit: 'contain', // 비율 유지
                transform: `rotate(${params?.row?.rotate}deg)`,
              }}
            />
          </div>
        )
      },
    },

    // {
    //   field: 'processStatus',
    //   headerName: '이미지 처리상태',
    //   width: 170,
    //   align: 'center',
    //   headerAlign: 'center',
    //   renderCell: (params: any) => {
    //     const status = params?.row?.processStatus
    //     const enumStatus = ImageProcessStatusEnum[status as keyof typeof ImageProcessStatusEnum]
    //     return <span>{status === 'digital' ? '디지털 계량기' : enumStatus}</span>
    //   },
    // },
    {
      field: 'checkValue',
      headerName: '검침 값',
      width: 150,
      align: 'center',
      headerAlign: 'center',
      renderCell: (params: any) => {
        return (
          <>
            <div className={'d-flex justify-content-center'}>
              <span>
                {params.row.checkValue === '' || params.row.checkValue === null ? (
                  <span className={'text-danger'}>인식불가</span>
                ) : (
                  params.row.checkValue
                )}
              </span>
              <span>
                {params.row.checkDecimalValue === '' || params.row.checkDecimalValue === null
                  ? ''
                  : '.' + params.row.checkDecimalValue?.split('.')[1]}
              </span>
            </div>
          </>
        )
      },
    },
    {
      field: 'valueUpdate',
      headerName: '검침값 수정',
      width: 280,
      align: 'center',
      headerAlign: 'center',
      hide: data?.deviceType === 'digital' || data?.recognizedType === 'PRV',
      renderCell: (params: any) => {
        const rowKey = `${params.row.imei}_${params.row.idxDate}`
        let localInput: HTMLInputElement | null = null
        return (
          <div className='d-flex justify-content-center gap-3' onClick={(e) => handleCellClick(e)}>
            <TextField
              sx={{textAlignLast: 'center'}}
              variant='outlined'
              size='small'
              defaultValue={params.row.checkValue}
              inputRef={(el) => (localInput = el)} // ✅ 콜백 ref
              autoComplete='off'
              onKeyDown={(e) => {
                if (e.key === 'Enter') {
                  const newVal = localInput?.value || ''
                  updateCheckValuePost(params.row, newVal)
                }
                if (e.ctrlKey && e.key === 'a') e.stopPropagation()
                if (['ArrowUp', 'ArrowDown', 'ArrowLeft', 'ArrowRight'].includes(e.key)) {
                  e.stopPropagation()
                }
              }}
              disabled={
                !accountTypeFixHandler(userInfo.accountType) ||
                params.row.processStatus === 'IMGERR'
              }
            />

            {accountTypeFixHandler(userInfo.accountType) && (
              <Button
                variant='contained'
                color={buttonColor(params.row.processStatus)}
                size='small'
                onClick={() => {
                  const newVal = localInput?.value || ''
                  updateCheckValuePost(params.row, newVal)
                }}
                disabled={params.row.processStatus === 'IMGERR'}
              >
                수정
              </Button>
            )}
          </div>
        )
      },
    },
    {
      field: 'temperature',
      headerName: '온도',
      width: 150,
      align: 'center',
      headerAlign: 'center',
      renderCell: (params: any) => {
        const temperature = params.row.temperature
        return (
          <>
            <div className={'d-flex justify-content-center'}>
              {temperature !== 99 && showTemperatureHandler(serverLocalName, officeInfo.value)
                ? `${temperature}°C`
                : '-'}
            </div>
          </>
        )
      },
    },
  ]
  const customerFields = [
    {label: '수용가번호', value: globalFormatWithHyphens(data?.officeId, data?.customerNumber)},
    {label: '수용가 이름', value: data?.customerName},
    {label: '수용가 주소', value: data?.addressRoad},
    {label: '계량기 번호', value: data?.meterNumber},
    {label: '계량기 구경', value: data?.meterDiameter + 'mm'},
    {label: '단말기 IMEI', value: data?.imei},
    {label: '단말기 SN', value: globalSerialNumberFormatWithHyphens(data?.serialNumber)},
  ]
  /*********************************************************************
   * 6. Page configuration
   *********************************************************************/

  return (
    <Modal
      open={open}
      onClose={() => {
        onCloseHandler()
      }}
      aria-labelledby={`${window.location.pathname}-label`}
      aria-describedby={`${window.location.pathname}-description`}
      closeAfterTransition
      slots={{backdrop: Backdrop}}
      slotProps={{
        backdrop: {
          timeout: 500,
        },
      }}
      id={'printTarget'}
      className={'printTarget'}
    >
      <>
        <Box sx={style}>
          <div className='flex flex-col h-full min-h-0'>
            <div className='flex justify-between items-center mb-2'>
              <Chip
                label={`${data?.imei} 상세정보`}
                variant={'outlined'}
                sx={{fontSize: isMobile ? '16px' : '20px', fontWeight: 'bold'}}
              />
              <CancelPresentationIcon
                sx={{fontSize: '40px', cursor: 'pointer'}}
                color={'error'}
                onClick={() => {
                  onCloseHandler()
                }}
              />
            </div>

            <div className='flex-1 min-h-0 overflow-y-auto lg:overflow-hidden'>
              {data && (
                <div className='flex flex-col lg:flex-row gap-4 lg:h-full'>
                  {/* 왼쪽: 수용가 정보 */}
                  <div className='w-full lg:w-1/4 min-w-0 flex flex-col lg:h-full'>
                    <div className='border border-1 border-gray-400 shadow-sm px-0 flex flex-col flex-1 min-h-0'>
                      <Paper className='p-4 border-bottom border-1 border-gray-400' square>
                        <span className='font-semibold text-[1.25rem]'>수용가 정보</span>
                      </Paper>
                      <Paper
                        className='p-4'
                        square
                        style={{flex: 1, overflow: 'auto', minHeight: 0}}
                        sx={!isMobile ? {'& .MuiInputBase-root': {height: 48}} : {}}
                      >
                        <div className='flex flex-col gap-2'>
                          {customerFields.map(({label, value}) => (
                            <div key={label} className='flex flex-col gap-1'>
                              <span className='flex items-center gap-1 font-semibold text-[1rem]'>
                                <DoubleArrowIcon /> {label}
                              </span>
                              <TextField
                                variant={'outlined'}
                                size='small'
                                className='bg-gray-300'
                                value={value}
                                inputProps={{readOnly: true}}
                              />
                            </div>
                          ))}
                        </div>
                      </Paper>
                    </div>
                    <div
                      id='map'
                      style={{width: '100%', height: 250}}
                      className='rounded-2 border-gray-400 border border-1 mt-2'
                    />
                  </div>

                  {/* 오른쪽: 날짜 + 차트 + 테이블 */}
                  <div className='flex-1 min-w-0 flex flex-col gap-2 lg:h-full lg:min-h-0'>
                    <div
                      className={`flex flex-wrap gap-2 items-center ${isMobile ? 'py-1' : 'py-3'}`}
                    >
                      <LocalizationProvider
                        dateAdapter={AdapterDayjs}
                        localeText={{start: '시작 날짜', end: '마지막 날짜'}}
                      >
                        <DateRangePicker
                          PopperProps={{style: {zIndex: 9999}}}
                          value={date}
                          calendars={3}
                          mask='____/__/__'
                          inputFormat={'YYYY/MM/DD'}
                          onChange={(newValue) => {
                            setDate(newValue)
                            setFilter({
                              ...filter,
                              startDate: newValue[0]?.format('YYYYMMDD'),
                              endDate: newValue[1]?.format('YYYYMMDD'),
                            })
                          }}
                          renderInput={(startProps, endProps) => (
                            <div className='flex items-center gap-2'>
                              <TextField
                                {...startProps}
                                size='small'
                                autoComplete='off'
                                InputLabelProps={{
                                  shrink: true,
                                  style: {fontSize: isMobile ? '1.2rem' : '1.5rem'},
                                }}
                                InputProps={{
                                  ...startProps.InputProps,
                                  sx: {
                                    height: 48,
                                    fontSize: isMobile ? '1.25rem' : '1.5rem',
                                  },
                                }}
                              />
                              <span className='text-slate-700 font-semibold'>~</span>
                              <TextField
                                {...endProps}
                                size='small'
                                autoComplete='off'
                                InputLabelProps={{
                                  shrink: true,
                                  style: {fontSize: isMobile ? '1.2rem' : '1.5rem'},
                                }}
                                InputProps={{
                                  ...endProps.InputProps,
                                  sx: {
                                    height: 48,
                                    fontSize: isMobile ? '1.25rem' : '1.5rem',
                                  },
                                }}
                              />
                            </div>
                          )}
                        />
                      </LocalizationProvider>
                      <Button
                        variant={'contained'}
                        color={'error'}
                        sx={{height: 48}}
                        onClick={async () => {
                          const today = dayjs()
                          const oneWeekAgo = today.subtract(7, 'day')
                          setFilter({
                            ...filter,
                            startDate: dayjs().subtract(7, 'day').format('YYYYMMDD'),
                            endDate: dayjs().format('YYYYMMDD'),
                          })
                          setDate([oneWeekAgo, today])
                        }}
                      >
                        <RotateLeftTwoToneIcon
                          sx={{width: 24, height: 24}}
                        />
                      </Button>
                      <FormControl
                        sx={{minWidth: isMobile ? 110 : 120, height: 48}}
                        size='small'
                      >
                        {!isMobile && <InputLabel id='select-label'>기준 선택</InputLabel>}
                        <Select
                          labelId='select-label'
                          id='select'
                          value={selectedOption}
                          label={isMobile ? undefined : '기준 선택'}
                          onChange={(e) => setSelectedOption(e.target.value)}
                          sx={{height: 48}}
                        >
                          <MenuItem value='reading'>검침값</MenuItem>
                          <MenuItem value='usage'>사용량</MenuItem>
                        </Select>
                      </FormControl>
                      <Button
                        variant={'contained'}
                        sx={{height: 48}}
                        onClick={() => getImageList()}
                      >
                        <SearchIcon sx={{width: 24, height: 24}} />
                      </Button>
                      <Button
                        variant={'outlined'}
                        color={'success'}
                        startIcon={
                          <ListAltIcon
                            sx={{width: 24, height: 24}}
                          />
                        }
                        sx={{height: 48, textTransform: 'none'}}
                        onClick={() => getDownloadData()}
                      >
                        {isMobile ? 'Excel 다운' : 'Download'}
                      </Button>
                    </div>

                    <div
                      style={{
                        height: isMobile ? '240px' : '230px',
                        flexShrink: 0,
                        overflow: 'hidden',
                      }}
                    >
                      {imageList && (
                        <CustomerDetailChartFix
                          className='w-full px-3'
                          data={data}
                          date={date}
                          imageList={imageList}
                          filter={filter}
                          selectedOption={selectedOption}
                          chartHeight={isMobile ? 200 : 190}
                          onDataClick={(e: any) => {
                            handleDateClick(e)
                          }}
                        />
                      )}
                    </div>

                    {isMobile ? (
                      <div className='flex flex-col' style={{height: '65vh'}}>
                        <div
                          ref={mobileListRef}
                          className='flex-1 overflow-y-auto flex flex-col gap-2'
                        >
                          {loading ? (
                            <div className='flex justify-center p-8'>
                              <span>로딩 중...</span>
                            </div>
                          ) : (
                            rows
                              .slice(mobilePage * pageSize, (mobilePage + 1) * pageSize)
                              .map((row) => {
                                let localInput: HTMLInputElement | null = null
                                return (
                                  <div
                                    key={row.id}
                                    className='border border-slate-300 rounded-lg p-3 bg-white shadow-sm flex gap-3'
                                  >
                                    {/* 왼쪽: 텍스트 정보 */}
                                    <div className='flex flex-col gap-1 flex-1 min-w-0'>
                                      <div className='font-bold text-slate-900'>
                                        <div className='text-xl'>
                                          {dayjs(row.createAt).format('YY/MM/DD')}
                                        </div>
                                        <div className='text-xl'>
                                          {dayjs(row.createAt).format('HH시 mm분 ss초')}
                                        </div>
                                      </div>
                                      <div className='flex items-center gap-2'>
                                        <span className='text-xl text-slate-700'>검침값</span>
                                        <span className='text-2xl font-bold text-slate-900'>
                                          {row.checkValue === '' || row.checkValue === null ? (
                                            <span className='text-red-600'>인식불가</span>
                                          ) : (
                                            row.checkValue
                                          )}
                                          {row.checkDecimalValue
                                            ? '.' + row.checkDecimalValue.split('.')[1]
                                            : ''}
                                        </span>
                                      </div>
                                      <div className='flex gap-3 flex-wrap mt-1'>
                                        {showTemperatureHandler(serverLocalName, officeInfo.value) &&
                                          row.temperature !== 99 && (
                                            <span className='text-xl text-slate-700'>
                                              {row.temperature}°C
                                            </span>
                                          )}
                                      </div>
                                    </div>
                                    {/* 오른쪽: 이미지 + 수정 */}
                                    <div
                                      className='shrink-0 flex flex-col gap-2 items-center'
                                      style={{width: '50%'}}
                                    >
                                      {row.filePath && data?.deviceType !== 'digital' && (
                                        <img
                                          src={envImagePath + row.filePath}
                                          alt='check'
                                          className='w-full object-contain rounded cursor-zoom-in border border-slate-300'
                                          style={{
                                            maxHeight: 100,
                                            transform: `rotate(${
                                              (row.rotate > 90 && row.rotate < 270) ||
                                              (row.rotate < -90 && row.rotate > -270)
                                                ? 180
                                                : 0
                                            }deg)`,
                                          }}
                                          onClick={() => {
                                            setIsZoomOpen(true)
                                            setSelectedImage(envImagePath + row.filePath)
                                          }}
                                        />
                                      )}
                                      {data?.deviceType !== 'digital' &&
                                        data?.recognizedType !== 'PRV' && (
                                          <div
                                            className='flex flex-row gap-1 w-full items-stretch'
                                            onClick={(e) => handleCellClick(e)}
                                          >
                                            <TextField
                                              variant='outlined'
                                              size='small'
                                              defaultValue={row.checkValue}
                                              inputRef={(el) => (localInput = el)}
                                              autoComplete='off'
                                              disabled={
                                                !accountTypeFixHandler(userInfo.accountType) ||
                                                row.processStatus === 'IMGERR'
                                              }
                                              onKeyDown={(e) => {
                                                if (e.key === 'Enter')
                                                  updateCheckValuePost(row, localInput?.value || '')
                                              }}
                                              sx={{
                                                flex: 1,
                                                '& .MuiInputBase-root': {
                                                  height: 48,
                                                  fontSize: '1.25rem',
                                                },
                                              }}
                                            />
                                            {accountTypeFixHandler(userInfo.accountType) && (
                                              <Button
                                                variant='contained'
                                                color={buttonColor(row.processStatus)}
                                                disabled={row.processStatus === 'IMGERR'}
                                                sx={{
                                                  height: 48,
                                                  minWidth: 0,
                                                  px: 2,
                                                  fontSize: '1.125rem',
                                                }}
                                                onClick={() =>
                                                  updateCheckValuePost(row, localInput?.value || '')
                                                }
                                              >
                                                수정
                                              </Button>
                                            )}
                                          </div>
                                        )}
                                    </div>
                                  </div>
                                )
                              })
                          )}
                        </div>
                        {/* 페이지네이션 */}
                        <div className='flex items-center justify-between border-t pt-2 mt-1 shrink-0'>
                          <FormControl
                            size='small'
                            sx={{
                              minWidth: 90,
                              '& .MuiInputBase-root': {height: 44, fontSize: '1.125rem'},
                            }}
                          >
                            <Select
                              value={pageSize}
                              onChange={(e) => {
                                setPageSize(Number(e.target.value))
                                setMobilePage(0)
                              }}
                            >
                              {[10, 20, 60, 100].map((s) => (
                                <MenuItem key={s} value={s}>
                                  {s}
                                </MenuItem>
                              ))}
                            </Select>
                          </FormControl>
                          <span className='text-lg text-slate-700'>
                            {mobilePage * pageSize + 1}–
                            {Math.min((mobilePage + 1) * pageSize, rows.length)} / {rows.length}
                          </span>
                          <div className='flex gap-1'>
                            <Button
                              variant='outlined'
                              sx={{minWidth: 52, height: 44, fontSize: '1.5rem', lineHeight: 1}}
                              disabled={mobilePage === 0}
                              onClick={() => {
                                setMobilePage((p) => p - 1)
                                mobileListRef.current && (mobileListRef.current.scrollTop = 0)
                              }}
                            >
                              ‹
                            </Button>
                            <Button
                              variant='outlined'
                              sx={{minWidth: 52, height: 44, fontSize: '1.5rem', lineHeight: 1}}
                              disabled={(mobilePage + 1) * pageSize >= rows.length}
                              onClick={() => {
                                setMobilePage((p) => p + 1)
                                mobileListRef.current && (mobileListRef.current.scrollTop = 0)
                              }}
                            >
                              ›
                            </Button>
                          </div>
                        </div>
                      </div>
                    ) : (
                      <Box id='table-content' sx={{flex: 1, minHeight: 0, width: '100%'}}>
                        <DataGridPro
                          rows={rows}
                          columns={columns}
                          rowHeight={110}
                          getRowHeight={(params: any) => getRowHeightOnDataGrid(params)}
                          apiRef={apiRef}
                          pageSize={pageSize}
                          onPageSizeChange={(newPageSize) => setPageSize(newPageSize)}
                          rowsPerPageOptions={[10, 20, 60, 100]}
                          disableColumnMenu
                          pagination
                          loading={loading}
                        />
                      </Box>
                    )}
                  </div>
                </div>
              )}
            </div>
          </div>
        </Box>
        {isZoomOpen && selectedImage && (
          <Lightbox
            mainSrc={selectedImage}
            wrapperClassName='target-image-light-box'
            reactModalStyle={targetImageLightBoxStyle(isMobile)}
            onCloseRequest={() => {
              setIsZoomOpen(false)
              setSelectedImage('')
            }}
          />
        )}
      </>
    </Modal>
  )
}

export default CustomerStatusTargetImageListModal
